const slugify = require('slugify')
const translations = require('../translations.json')

const pad0 = numString => numString.padStart(2, '0')

const dateStringToNum = dateString => {
  const dateArray = dateString.split('_')
  return parseInt([dateArray[0], pad0(dateArray[1])].join(''))
}

export const toDecimalDate = date => {
  const dateString = typeof date === 'number' ? date.toString() : date
  const dateArr = dateString.split('_')
  return parseFloat(dateArr[0]) + parseFloat(dateArr[1] || 0) / 100
}
export const DataFormatter = class {
  constructor (data, itemType) {
    this.itemType = itemType
    this.geometryids = []
    const { title, body, url } = data
    const mediaType = data.type
    if (mediaType === 'video') {
      let videoData = null
      if (data.video[0]) {
        const videoCandidate1 = data.video[0].sources.find(videoUrlItem => {
          return videoUrlItem.type === 'video/mp4' && (videoUrlItem.label === 'High SD')
        })
        const videoCandidate2 = data.video[0].sources.find(videoUrlItem => {
          return videoUrlItem.type === 'video/mp4' && (videoUrlItem.label === 'Low SD')
        })
        this.picture = data.video[0].image
        videoData = videoCandidate1 || videoCandidate2
      }
      this.video = videoData ? videoData.file : null
    } else if (mediaType === 'album') {
      this.picture = data.album[0]['640']
    } else {
      this.img = data.picture['640']
    }
    Object.assign(this, { title, body, url, mediaType, itemType })

    const taxonomy = data.taxonomy ? data.taxonomy[1] : null
    const tags = taxonomy ? Object.keys(taxonomy).map(key => taxonomy[key]).map(obj => obj.tag) : []
    tags.map(tag => {
      const tagArray = tag.split('_')
      const [ key, ...values ] = tagArray
      const value = values.join('_')
      if (key === 'geometryid' && this.itemType === 'event') this.geometryids.push(parseInt(value))
      else this[key] = value // necessary for tag date like 1900_1
    })
    this.mp3 = data.audio && data.audio[0] ? data.audio[0].sources.find(source => source.default).file : null
    this.slug = this.url.split('/').pop()
  }
}

export const sortByDate = (a, b) => {
  const num1 = dateStringToNum(a.date)
  const num2 = dateStringToNum(b.date)
  const compare = num1 - num2
  return compare
}

export const sortByScenarioIdAndYear = (a, b) => {
  const id1 = parseInt(a.scenarioID || 0)
  const id2 = parseInt(b.scenarioID || 0)
  const year1 = parseInt(a.year || 0)
  const year2 = parseInt(b.year || 0)
  const compare = id1 - id2 || year1 - year2
  return compare
}

export const getTranslations = () => {
  const messages = {
    en: {
      message: {}
    },
    iu: {
      message: {}
    }
  }
  translations.forEach(element => {
    const regex = /'/gi
    const slug = slugify(element['English '].substring(0, 20), '_').replace(regex, '_')
    if (!messages.en.message[slug]) {
      messages.en.message[slug] = element['English ']
    } else {
      messages.en.message[slug + '_2'] = element['English ']
    }
    if (!messages.iu.message[slug]) {
      messages.iu.message[slug] = element['Syllabics ']
    } else {
      messages.iu.message[slug + '_2'] = element['Syllabics ']
    }
  })
  return messages
}
